import { ReactElement } from 'react'

import {
  BankConnectionErrorBody,
  BankConnectionErrorType,
} from '@features/bankAccounts/elements/BankConnectionErrorBody'

import { useShineConnectModal } from '../../contexts/shineConnectModalContext'

export const ErrorModalBody = (): ReactElement => {
  const { handleCloseModal, hasMergeFailed, hasMergeSucceeded } = useShineConnectModal()

  const errorType =
    hasMergeFailed || hasMergeSucceeded ? BankConnectionErrorType.ShineMerge : BankConnectionErrorType.ShineConnect

  return <BankConnectionErrorBody errorType={errorType} onClose={handleCloseModal} />
}
